import { Component } from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import DOMPurify from 'dompurify';
import classnames from 'classnames';
import MessageBody from './message-body';
import MessageFooter from './message-footer';
import MessageSender from './message-sender';
import { MESSAGE_RECEIVED } from '../../data/messageTypes';
import MessageSubject from './message-subject';

class MessageDetails extends Component {
  messageContent() {
    const { message } = this.props;
    let content = message.attributes.body;

    if (!message.attributes['system-message']) {
      content = content.replace(/\n/g, '<br>');
    }

    return (<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}}/>);
  }

  render() {
    const {
      message, onDelete, toggleMessage, toggleReply, reply, replyComponent, messageType
    } = this.props;
    return (
      <Row className={classnames({
        'message-details': true,
        reply
      })}
      >
        <Col lg={12}>
          <Card className="message-item">
            <Card.Body>
              <MessageSender type={messageType} message={message}/>
              <MessageSubject message={message}/>
              <div className="clearfix mg-bottom-20"/>
              <MessageBody>{this.messageContent()}</MessageBody>
              {reply && replyComponent}
            </Card.Body>
            <Card.Footer>
              <MessageFooter
                toggleReply={toggleReply}
                reply={messageType === MESSAGE_RECEIVED && !message.attributes['system-message']}
                message={message}
                toggleMessage={toggleMessage}
                onDelete={onDelete}
                open
              />
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default MessageDetails;
